var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38672 12.0966C8.23866 9.46274 12.051 7.85352 16.2393 7.85352C20.4275 7.85352 24.2398 9.46274 27.0918 12.0966M8.77814 15.7706C10.7388 13.9599 13.3599 12.8535 16.2393 12.8535C19.1187 12.8535 21.7397 13.9599 23.7004 15.7706M12.1696 19.4447C13.239 18.457 14.6687 17.8535 16.2393 17.8535C17.8098 17.8535 19.2395 18.457 20.309 19.4447",
    stroke: "#E6E9ED",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4661 23.2096C17.4661 23.8874 16.9167 24.4368 16.2389 24.4368C15.5612 24.4368 15.0117 23.8874 15.0117 23.2096C15.0117 22.5319 15.5612 21.9824 16.2389 21.9824C16.9167 21.9824 17.4661 22.5319 17.4661 23.2096Z",
    fill: "#383B41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork4);
export default __webpack_public_path__ + "static/media/network-4.2b0dd89bc617cae3074db873725527b3.svg";
export { ForwardRef as ReactComponent };